<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Form ref="formValidate" :model="formValidate" :label-width="110">
        <Row>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商名称:" prop="agentName">
              <Input v-model.trim="formValidate.agentName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品编号:" prop="commodityId">
              <Input v-model.trim="formValidate.commodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="文件名:" prop="fileName">
              <Input v-model.trim="formValidate.fileName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="批次号:" prop="batchId">
              <Input v-model.trim="formValidate.batchId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="开始时间:" prop="startDate">
              <DatePicker type="datetime" v-model="formValidate.startDate" placeholder="请选择" style="width:100%" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="结束时间:" prop="endDate">
              <DatePicker type="datetime" v-model="formValidate.endDate" placeholder="请选择" style="width:100%" />
            </FormItem>
          </Col>
          <Col :md='24' class="text-right">
            <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
            <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col :md='24' style="margin-bottom: 20px">
          <Button
            type="primary"
            icon="md-add"
            style="margin-right: 8px"
            @click="batchRecharge"
          >批量充值</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{row}" slot="rechargeResult">
          <RechargeResult :resultFail="row.failNum" :resultSuccess="row.succressNum"  />
        </template>
        <template slot-scope="{row}" slot="action">
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-download"
            @click="exportItem(row)"
          >导出失败订单</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <BatchRecharge ref="batchRecharge" @success="rechargeSuccess" />
    <ExportFile ref="exportFile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import utils from '../../utils'
import BatchRecharge from '../../components/recharge/BatchRecharge'
import RechargeResult from '../../components/recharge/RechargeResult'
import ExportFile from '../../components/common/ExportFile'

export default {
  components: {
    BatchRecharge,
    RechargeResult,
    ExportFile
  },
  data () {
    return {
      formValidate: {
        agentId: null,
        commodityId: null,
        fileName: null,
        batchId: null,
        startDate: null,
        endDate: null
      },
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1
    }
  },
  computed: {
    startDate () {
      return this.formValidate.startDate ? this.formValidate.startDate.getTime() : null
    },
    endDate () {
      return this.formValidate.endDate ? this.formValidate.endDate.getTime() : null
    },
    startDateText () {
      return this.startDate ? utils.formatDateTime(this.startDate) : ''
    },
    endDateText () {
      return this.endDate ? utils.formatDateTime(this.endDate) : ''
    },
    ...mapGetters('recharge', ['rechargeStatus']),
    queryColumn () {
      return [
        {
          title: '批次号',
          key: 'id',
          minWidth: 150
        },
        {
          title: '文件名',
          key: 'fileName',
          minWidth: 150
        },
        {
          title: '代理商名称',
          key: 'agentName',
          minWidth: 150
        },
        {
          title: '商品编号',
          key: 'commodityId',
          minWidth: 150
        },
        {
          title: '导入时间',
          key: 'createDate',
          minWidth: 190,
          render: (h, params) => {
            return h('span', utils.formatDateTime(params.row.createDate))
          }
        },
        {
          title: '订单数量',
          key: 'totalNum',
          minWidth: 150
        },
        {
          title: '充值结果',
          key: 'rechargeResult',
          minWidth: 100,
          slot: 'rechargeResult',
          align: 'center'
        },
        {
          title: '操作',
          key: 'batchId',
          minWidth: 150,
          slot: 'action',
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    formSubmit () {
      // 判断开始时间和结束时间
      if (this.startDate && this.endDate && (this.startDate >= this.endDate)) {
        this.$Message.error('开始时间不能大于或等于结束时间！')
        return
      } else if (this.startDate && !this.endDate) {
        this.$Message.error('请选择结束时间！')
        return
      } else if (!this.startDate && this.endDate) {
        this.$Message.error('请选择开始时间！')
        return
      }
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset () {
      this.$refs['formValidate'].resetFields()
      this.formSubmit()
    },
    getData () {
      this.loading = true
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          const element = this.formValidate[item]
          if (element !== null && element !== '') {
            params[item] = element
          }
        }
      }
      if (this.startDate) {
        params.startDate = this.startDate
      }
      if (this.endDate) {
        params.endDate = this.endDate
      }
      params.pageSize = this.pageSize
      params.pageNum = this.pageNum
      api.recharge.batchOrderList({
        ...params
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 导出失败订单
    exportItem (row) {
      this.$refs.exportFile.submit(api.recharge.exportBatchFailList, 'get', {
        batchId: row.id
      })
    },
    // 批量充值
    batchRecharge () {
      this.$refs.batchRecharge.show()
    },
    // 充值成功
    rechargeSuccess () {
      this.getData()
    }
  },
  created () {
    this.getData()
  }
}
</script>
